/**
 * Every API-key scope the stored RevenueCat key must carry, in the three
 * sections RevenueCat's own key screen groups them under.
 *
 * The first two sections are what the analytics service's RevenueCat routes
 * need; the third is what this service's `fetch_revenuecat_data` tool calls
 * with the SAME stored key — hence the "(used by the Audit)" note, which the
 * copy keeps even here, where the reader is already inside the Audit, because
 * the same words are shown in the back office (VIBE-2147).
 *
 * 🔴 mvp-frontend shows this list and the Connect copy word for word
 * (`lib/revenuecat/constants.ts` + `app/components/RevenueCatConnectionModal.tsx`).
 * The two repositories share no package, so a change here must be repeated
 * there. Only one of these scopes is proven when the key is saved; a missing
 * one surfaces later, when a chart or a lookup needs it.
 */
export const REVENUECAT_REQUIRED_SCOPE_SECTIONS = [
  {
    label: 'Charts & Metrics',
    covers: 'revenue, MRR, trials, churn',
    scopes: ['charts_metrics:overview:read', 'charts_metrics:charts:read'],
  },
  {
    label: 'Project Configuration',
    covers: 'your apps, products and offerings',
    scopes: [
      'project_configuration:apps:read',
      'project_configuration:products:read',
      'project_configuration:offerings:read',
      'project_configuration:packages:read',
      'project_configuration:projects:read',
    ],
  },
  {
    label: 'Customer Information',
    covers: 'subscriptions and purchases (used by the Audit)',
    scopes: [
      'customer_information:subscriptions:read',
      'customer_information:purchases:read',
    ],
  },
] as const;

/** The same nine scopes as one flat list, in section order. */
export const REVENUECAT_REQUIRED_SCOPES: readonly string[] =
  REVENUECAT_REQUIRED_SCOPE_SECTIONS.flatMap((section) => section.scopes);
